import React, { useState, Component } from 'react';
import { motion } from 'framer-motion';
export function AlquilerApps() {
  const [formData, setFormData] = useState({
    nombre: '',
    telefono: '',
    localidad: '',
    registro: 'Registro profesional',
    modalidad: 'Turno — 12 horas',
    trabaja: 'No, quiero empezar'
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const message = `Hola Flash & Go! Me interesa alquilar un auto para apps. Mis datos:
*Nombre:* ${formData.nombre}
*Teléfono:* ${formData.telefono}
*Localidad:* ${formData.localidad}
*Registro:* ${formData.registro}
*Modalidad:* ${formData.modalidad}
*¿Trabaja en app?:* ${formData.trabaja}`;
    window.open(`https://wa.me/5491127063704?text=${encodeURIComponent(message)}`, '_blank');
  };
  const cards = [{
    badge: '12 HORAS',
    title: 'Turno',
    desc: 'Alquilá el auto por turno de 12 horas. Ideal para arrancar a generar ingresos de forma flexible.'
  }, {
    badge: '24 HORAS',
    title: 'A cargo',
    desc: 'El auto es tuyo las 24 horas. Máxima disponibilidad para maximizar tus ganancias.'
  }, {
    badge: 'MES 12 ES TUYO',
    title: 'Alquiler con opción a compra',
    desc: 'Alquilás, trabajás y al mes número 12 el auto pasa a ser tuyo. La forma más inteligente de tener tu propio auto.'
  }];
  return <section id="alquiler" className="py-32 bg-brand-black relative" data-id="element-76" data-mp="25xfrzpranoyn">
      <div className="max-w-7xl mx-auto px-6" data-id="element-77" data-mp="25wmt1ayku3r2">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-78" data-mp="21vb2n37vpeht">
          <h2 className="font-heading text-5xl md:text-6xl text-brand-white mb-4" data-id="element-79" data-mp="lhb4nxslfyx7">
            Trabajá en apps con{' '}
            <span className="text-brand-gold" data-id="element-80" data-mp="gi88z3yi751w">nuestros autos</span>
          </h2>
          <p className="text-xl text-brand-gold" data-id="element-81" data-mp="hzwvf5qa87kc">
            Uber · Cabify · inDriver · Beat y más
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8 mb-16" data-id="element-82" data-mp="mxgk6zklw2qj">
          {cards.map((card, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-[#111] border border-brand-gold/30 p-8 rounded-xl relative" data-id="element-83" data-mp="8xxfkgr079iz" data-mpi={i}>
              <div className="absolute -top-4 left-8 bg-brand-gold text-brand-black text-xs font-bold px-3 py-1 rounded-full" data-id="element-84" data-mp="3qep1nibf90kq">
                {card.badge}
              </div>
              <h3 className="font-heading text-3xl text-brand-white mt-4 mb-4" data-id="element-85" data-mp="3heiqw473yep9">
                {card.title}
              </h3>
              <p className="text-brand-white/70 leading-relaxed" data-id="element-86" data-mp="2xu1pqgmet11h">{card.desc}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-3xl mx-auto bg-[#111] border border-brand-gold/30 p-8 rounded-xl relative overflow-hidden" data-id="element-87" data-mp="2svqfi4s7coiq">
          <div className="absolute top-0 left-0 w-full h-1 bg-brand-gold" data-id="element-88" data-mp="3btjfay7j4ibw"></div>
          <h3 className="font-heading text-3xl text-brand-gold mb-6 text-center" data-id="element-89" data-mp="3qi7ah3dgqq1b">
            Quiero alquilar un auto
          </h3>

          <form onSubmit={handleSubmit} className="space-y-4" data-id="element-90" data-mp="3ljvyon3ly5gg">
            <div className="grid md:grid-cols-2 gap-4" data-id="element-91" data-mp="3cgcerfpjn41">
              <div data-id="element-92" data-mp="3d7ztez5iej8">
                <label className="block text-sm text-brand-white/70 mb-1" data-id="element-93" data-mp="3vgqxz87pg9vs">
                  Nombre completo
                </label>
                <input required type="text" className="w-full bg-[#1a1a1a] border border-brand-white/10 rounded p-3 text-brand-white focus:border-brand-gold outline-none transition-colors" onChange={e => setFormData({
                ...formData,
                nombre: e.target.value
              })} data-id="element-94" data-mp="1suvbo8y785vf" />
              </div>
              <div data-id="element-95" data-mp="1euaqj64t9xyr">
                <label className="block text-sm text-brand-white/70 mb-1" data-id="element-96" data-mp="1etiww0uryab4">
                  Teléfono
                </label>
                <input required type="tel" className="w-full bg-[#1a1a1a] border border-brand-white/10 rounded p-3 text-brand-white focus:border-brand-gold outline-none transition-colors" onChange={e => setFormData({
                ...formData,
                telefono: e.target.value
              })} data-id="element-97" data-mp="1jsm5fv9yqynu" />
              </div>
            </div>

            <div data-id="element-98" data-mp="jmibl54n40lb">
              <label className="block text-sm text-brand-white/70 mb-1" data-id="element-99" data-mp="jm0iuih6s4i5">
                Localidad / Barrio
              </label>
              <input required type="text" className="w-full bg-[#1a1a1a] border border-brand-white/10 rounded p-3 text-brand-white focus:border-brand-gold outline-none transition-colors" onChange={e => setFormData({
              ...formData,
              localidad: e.target.value
            })} data-id="element-100" data-mp="9vfba5jjbpn3" />
            </div>

            <div className="grid md:grid-cols-2 gap-4" data-id="element-101" data-mp="3n38weq4vsi72">
              <div data-id="element-102" data-mp="1q9dvdd22pzc5">
                <label className="block text-sm text-brand-white/70 mb-1" data-id="element-103" data-mp="1q9xf8zbaaxst">
                  Tipo de registro
                </label>
                <select className="w-full bg-[#1a1a1a] border border-brand-white/10 rounded p-3 text-brand-white focus:border-brand-gold outline-none transition-colors" onChange={e => setFormData({
                ...formData,
                registro: e.target.value
              })} data-id="element-104" data-mp="1lbcbwr0qjy05">
                  <option data-id="element-105" data-mp="20du9o1zwn8du">Registro profesional</option>
                  <option data-id="element-106" data-mp="2o2n5lygj1g8g">Registro particular</option>
                  <option data-id="element-107" data-mp="2o12defhoq9dr">No tengo registro</option>
                </select>
              </div>
              <div data-id="element-108" data-mp="2s3yz4f2iullx">
                <label className="block text-sm text-brand-white/70 mb-1" data-id="element-109" data-mp="2e4zdlgab2mtz">
                  Modalidad
                </label>
                <select className="w-full bg-[#1a1a1a] border border-brand-white/10 rounded p-3 text-brand-white focus:border-brand-gold outline-none transition-colors" onChange={e => setFormData({
                ...formData,
                modalidad: e.target.value
              })} data-id="element-110" data-mp="2j3kb37y6aseq">
                  <option data-id="element-111" data-mp="v746kz67zjhx">Turno — 12 horas</option>
                  <option data-id="element-112" data-mp="v8f7mr8a6d5c">A cargo — 24 horas</option>
                  <option data-id="element-113" data-mp="196c4zpuk6nl2">Alquiler con opción a compra</option>
                </select>
              </div>
            </div>

            <div data-id="element-114" data-mp="147iu856npaol">
              <label className="block text-sm text-brand-white/70 mb-2" data-id="element-115" data-mp="144wlw3bxyr5b">
                ¿Trabajás actualmente en alguna app?
              </label>
              <div className="flex gap-4" data-id="element-116" data-mp="cgmgl2crv209">
                {['Sí', 'No, quiero empezar'].map(opt => <label key={opt} className="flex items-center gap-2 text-brand-white cursor-pointer" data-id="element-117" data-mp="q89pc1nwi2zx">
                    <input type="radio" name="trabaja" value={opt} className="accent-brand-gold" onChange={e => setFormData({
                  ...formData,
                  trabaja: e.target.value
                })} defaultChecked={opt === 'No, quiero empezar'} data-id="element-118" data-mp="3twbbduvygolk" />
                    {opt}
                  </label>)}
              </div>
            </div>

            <button type="submit" className="w-full mt-6 py-4 bg-brand-gold text-brand-black font-bold rounded hover:bg-brand-white transition-colors" data-id="element-119" data-mp="3na8xvo01ux2r">
              QUIERO ALQUILAR
            </button>
          </form>
        </motion.div>
      </div>

      {/* Divider */}
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-brand-gold/30 to-transparent" data-id="element-120" data-mp="4wt0ih4uzjz3"></div>
    </section>;
}